import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa4',
  },
  theme: {
    // https://material.io/tools/color/#!/?view.left=0&view.right=0&primary.color=37474F&secondary.color=2E7D32
    themes: {
      light: {
        primary: colors.blueGrey.darken3, // #37474F
        secondary: colors.green.darken2, // #2E7D32
        accent: colors.blue.darken3, // #1565c0
      },
    },
  },
});
